import type { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';

interface Props {
  title: string;
  subtitle?: string;
}

export const SectionHeader: React.FC<Props> = ({ title, subtitle }) => {
  const theme = useTheme<LensTheme>();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.tokens.semantic.spacing.desktop.gap['0_5'].value,
      }}
    >
      <Typography
        component="h4"
        sx={{
          fontSize: '18px',
          fontWeight: 500,
          color: theme.tokens.semantic.color.type.default.value,
          m: 0,
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 400,
            color: theme.tokens.semantic.color.type.default.value,
            m: 0,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};
